<template>
  <div class="newIndex newIndexNew">  
    <div class="leftAllBox" > 
      <div class="box1">
        <div class="active-notice active-notice-left">
          <div class="box-content">
            <ul class="yzListUl">
              <li class="yzListDiv">
                <div class="yzListDivLeft yzListDivLeftBlue" @click="rightCardMessage='base'">
                  <img src="@/assets/images/personalIcon.png" alt/>
                  <div>
                    <p>组织简介</p>
                  </div>
                </div>
              </li>
              <li class="yzListDiv">
                <div class="yzListDivLeft yzListDivLeftViolet" @click="rightCardMessage='member'">
                  <img src="@/assets/images/enterpriseIcon.png" alt/>
                  <div>
                    <p>组织成员</p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="active-notice active-notice-right">
          <div v-if="photoSrc && partyInfo" class="box-content box-content-base" v-show="rightCardMessage == 'base'">
            <img :src="photoSrc" style="height:100%;width:50%;"/>
            <span class="jdjieshao" v-html="partyInfo">
            </span>
          </div>
          <div v-else class="box-content box-content-base" v-show="rightCardMessage == 'base'">
            <img :src="regular.photo" style="height:270px;width:370px;"/>
            <span class="jdjieshao" v-html="regular.introduce"></span>
          </div>
          <div class="box-content box-content-base" v-show="rightCardMessage == 'member'">
            <div v-for="(item,index) in menmberList" :key="index" class="memeber1">
                <div>
                  <img :src="item.photo"/>
                  <p class="">{{item.name}}</p>
                  <p>{{item.post}}</p>
                </div>
            </div>  
          </div>
          <div class="box-content communityVoluntaryService" v-show="rightCardMessage == 'list'">
            <!--            <community-voluntary-service v-show="rightCardMessage == 'list'"/>-->
          </div>
        </div>
      </div>
      <div class="box2">
        <div class="box2Content">
          <el-tabs style="width: 96%;margin:0 10px" type="card" v-model="personListValue" @tab-click="handleClickPersonList">
            <el-tab-pane v-for="(item,index) in personList" :key="index" :label="item.name" :name="item.id+''" 
            > 
            <!-- :introduce="item.introduce" :photo="item.photo" -->
              <el-table  :data="tableData" border style="width: 98%;margin:0 1%">
                <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>  
                <el-table-column
                  align="center"
                  prop="name"
                  width="180"
                  label="姓名"
                ></el-table-column>
                <el-table-column
                  width="90"
                  align="center"
                  prop="sex"
                  label="性别"
                >
                  <template scope="scope">
                    <span v-if="scope.row.sex == 0">男</span>
                    <span v-if="scope.row.sex == 1">女</span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="phone"
                  width="180"
                  label="手机号"
                ></el-table-column>
                <el-table-column
                  align="center"
                  width="380"
                  prop="parentPersonTypeName"
                  label="类别"
                  :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="consultOrgName"
                  label="所属组织"
                  :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="createDate"
                  label="创建时间"
                  :show-overflow-tooltip="true"
                ></el-table-column> 
                <el-table-column
                  align="center"
                  prop="approvalStatus"
                  label="审批状态"
                  width="130"
                >
                  <template scope="scope">
                    <span
                      class="tab"
                      :class="{
                        active_tab2: scope.row.approvalStatus == '1',
                        active_tab1: scope.row.approvalStatus == '0',
                        active_tab: scope.row.approvalStatus == '2',
                      }"
                      >{{
                        scope.row.approvalStatus == "1"
                          ? "同意"
                          : scope.row.approvalStatus == "2"
                          ? "不同意"
                          : "待审批"
                      }}</span
                    >
                  </template>
                </el-table-column>
                <!-- <el-table-column
                  align="center"
                  prop="status"
                  label="状态"
                  width="150px"
                >
                  <template scope="scope">
                    <el-switch
                      v-model="scope.row.status"
                      active-value="0"
                      inactive-value="1"
                      @change="changeStatus(scope.row)"
                    ></el-switch>
                  </template>
                </el-table-column> -->
                <el-table-column align="center" fixed="right" label="操作" width="170">
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="light" content="查看" style="color: green" placement="top-start" >
                      <button  class="iconfont icon-chakan tabBtn"  @click="look(scope.row,'look')" ></button>
                    </el-tooltip>
                    <!-- <el-tooltip class="item" effect="light" content="编辑" style="color: blue" placement="top-start" >
                      <button  class="iconfont icon-bianji3 tabBtn"  @click="look(scope.row,'edit')" ></button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="light" content="删除" style="color: red" placement="top-start" >
                      <button  class="iconfont icon-icon7 tabBtn"  @click="delet(scope.row)" ></button>
                    </el-tooltip>  -->
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                :page-size="pageConfig.pageSize" 
                layout="total, prev, pager, next, jumper" 
                @current-change="handleCurrentChange"
                :total="pageConfig.total"></el-pagination>
            </el-tab-pane> 
          </el-tabs>
          <!-- 弹出框新增/修改/查看 -->
          <el-dialog :title="dialogTitle" :visible.sync="dialogVisible"  width="60%" :before-close="handleClose">
            <el-form ref="addform" :rules="rules" :model="addform" label-width="360px" style="position: relative;" >
              <el-form-item label-width="150px" label="姓名：">
                <el-input :disabled="readyOnly" v-model="addform.name" class="winput"></el-input>
              </el-form-item>
              <el-form-item label-width="150px" label="性别：">
                <el-select :disabled="readyOnly" v-model="addform.sex" class="winput" placeholder="--请选择--" >
                  <el-option label="男" value="0"></el-option>
                  <el-option label="女" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label-width="150px" label="身份证号：">
                <el-input :disabled="readyOnly" v-model="addform.idCode" class="winput"></el-input>
              </el-form-item>
              <el-form-item label-width="150px" label="手机号码：">
                <el-input :disabled="readyOnly" v-model="addform.phone" class="winput"></el-input>
              </el-form-item> 
              <el-form-item label-width="150px" label="所属组织：">
                <el-select :disabled="readyOnly" v-model="organization" class="winput" >
                  <el-option v-for="(item, index) in consultOrgList" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select> 
              </el-form-item>
              <el-form-item label-width="150px" label="类别：">
                <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange" > 
                  <el-checkbox :disabled="readyOnly" v-for="item in cities" :label="item.id" :key="item.id" :value="item.id">{{ item.consultName }}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item prop="photoPath"  class="zjimg"> 
                <div class="threestyleimg">
                  <div class="threestyleimgtu">
                    <img :src="eddimgurl" alt style="width:170px;height: 200px; " />
                  </div>
                  <div class="threestyleimgbtn">
                    <div>专家照片</div>
                    <input type="file" @change="upimg" />
                  </div>
                </div>
              </el-form-item>
              <el-form-item label-width="150px" label="状态：" prop="status">
                <el-radio-group :disabled="readyOnly" v-model="addform.status">
                  <el-radio label="0">启用</el-radio>
                  <el-radio label="1">禁用</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script> 
import { post } from "@/api/requrestHttp";
export default {
  data() {
    return {
      addform:{},
      menmberList:[],
      consultOrgList:[],
      checkedCities: [],
      checkedList : [],
      cities:[],
      readyOnly: false,
      rightCardMessage: "base", 
      photoSrc: '',
      partyInfo: '',
      organization:'',
      dialogTitle:'查看',
      regular:{},
      tableData:[],
      personListValue:'124',
      personList:[],
      parentPersonTypeId: "",
      rules: { 
        name: [{ required: true, message: "请输入姓名", trigger: "blur" , trigger: "blur",}],
        sex: [{ required: true, message: "请选择性别", trigger: "blur" , trigger: "blur",}], 
        phone: [{ required: true, message: '请输入手机号', trigger: "blur",}],
        idCode: [{required: true, min:18,  message: "请输入18位身份证号码", trigger: "blur",}],  
        photoPath: [{ required: false, message: "请上传照片", trigger: "blur" }],
        status: [{ required: true, message: "请选择启动状态", trigger: "change", }],
      },
      eddimgurl: require("../../../assets/images/partyMemberManagementcopy/imgjia.png"),
      dialogVisible: false,
      psid:'',
      pageConfig: {
        pageSize: 5,
        total: 0,
        pageNo: 1
      }, 
    };
  },
  components: {
    
  },
  methods: {
    look(data,flag ){
      this.organization = ''
      this.checkedCities = [] 
      this.eddimgurl = require("../../../assets/images/partyMemberManagementcopy/imgjia.png");
      this.getConsuOrgLlist();
      this.dialogVisible = true
      if(flag == 'look'){
        this.readyOnly = true;
      }  
      let fd = new FormData(); 
      fd.append("id", data.id); 
      post("admin/consulType/info/findConsultPersonById",fd).then(res => {
          console.log(res); 
          if (res.code == 200) {
          res.content.phone = Number(res.content.phone);
          this.addform = res.content;
          console.log(this.addform.parentPersonTypeId);
          this.organization = this.addform.consultOrgName
          var arr = []
          if(this.addform.photoPath){
            this.eddimgurl = this.addform.photoPath
          }else{
            this.eddimgurl = require("../../../assets/images/partyMemberManagementcopy/imgjia.png");
          }
          this.checkedCities = this.addform.parentPersonTypeId.split(",")
          this.checkedCities.forEach(item => {
            item = +item;
            this.checkedList.push(item)
          })
          this.checkedCities = this.checkedList 
          console.log(this.checkedCities);
          this.fileList = [];
          var temp = {};
          if (res.content.enclosurePath) {
            var namesArr = [];
            if (res.content.enclosureName) {
              namesArr = res.content.enclosureName.split(",");
            }

            var enclosureArr = res.content.enclosurePath.split(",");
            enclosureArr.forEach((item, index) => {
              if (item != "") {
                temp = {
                  name: namesArr[index] ? namesArr[index] : "附件" + index,
                  url: item,
                };
                this.fileList.push(temp);
              }
            });
          }
        } else {
          //   console.log(res.code + "：" + res.message);
          this.$message({
            message: "数据加载异常",
            type: "error",
          });
          this.showadd = false;
          this.showaudit = false;
        }
      })
    },
    findConsultPersonTypeList() {
      post("/admin/consultPersonType/info/findConsultPersonTypeList", {
        pageNo: 1,
        pageSize: 100,
        status: 0,
      }).then((res) => {
        // console.log(res.content.list);
        res.content.list.forEach((item) => {
          // console.log(item.consultName);
          this.cities.push(item);
        });
      });
    },
    handleCheckedCitiesChange(value) {
      this.parentPersonTypeId = value; 
    },
    // 上传图片
    async upimg(e) {
      if (e.target.files[0] == undefined) {
        return false;
      } else {
        let res = await uploadPartyPhoto(e.target.files[0]);
        this.eddimgurl = res.content;
      }
    },
    handleClose(){
      this.organization = '',
      this.dialogVisible = false 
    },
    getConsuOrgLlist() {
      post("/admin/consulOrg/info/listConsultOrg", {
        pageSize:9999,
        pageNo:1,
        status:0,
      }).then((res) => {
        if (res.code == 200) { 
          this.consultOrgList = res.content.list;
        } else {
          this.$message.error(res.message);
        }
      });
    }, 
    //分页
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val;
      this.getPersonList(this.psid);
    },  
    handleClickPersonList(tab, event) { 
      this.getPersonList(tab.name)
    },
    //改变状态
    async changeStatus(cdata) {
      let fd = new FormData(); 
      let params = JSON.stringify(cdata);
      if (params != "{}") {
        fd.append("ConsultPerson", params);
      }

      var res = await request({
        url: "/admin/consulType/info/insertConsultPerson",
        method: "POST",
        data: fd,
      });

      // console.log(res)
      var msg = "状态";
      msg = msg + (cdata.status == "0" ? "启用" : "禁用");
      if (res.code == 200) {
        this.$message({
          message: msg + "成功",
          type: "success",
        });
      } else {
        console.log(res.message);
        this.$message({
          message: msg + "失败",
          type: "error",
        });
      }
    },
    delet(data){
      post("/admin/consulType/info/deleteConsultPerson",{
        id:data.id,
      }).then(res => {
          console.log(res); 
      })
    },
    // 组织获取
    async getOrgList() {
      post("/admin/consulOrg/info/listConsultOrg",{
        // ...this.searchRylist,
        pageNo: 1,
        pageSize: 999,
        status:0,
      }).then(res => {
          this.personList = res.content.list;
          this.pageConfig.total = res.content.count; 
          console.log(res.content.id);
          this.getPersonList(this.personList[0].id) 
      })
    },
    // 组织详情
    async getConsultOrg(tabId) { 
      post("/admin/consulOrg/info/getConsultOrg",{
        id: tabId,
      }).then(res => {  
          res.content.leaders.forEach(item => {
              if(item.post=='0'){
                  item.post='党委书记';
              }
              if(item.post=='1'){
                  item.post='党委副书记';
              }
              if(item.post=='2'){
                  item.post='记检委员';
              }
              if(item.post=='3'){
                  item.post='组织委员 ';
              }
              if(item.post=='4'){
                  item.post='其他委员';
              }
          })
          this.menmberList = res.content.leaders
          console.log(this.menmberList);
      })
    },
    async getPersonList(tabId) {
      console.log(11111,tabId);
      this.psid = tabId;
      if(tabId){
        this.personListValue = String(tabId)
      } 
      post("/admin/consulType/info/findConsultPersonList",{
        consultOrgId:this.personListValue,
        pageNo: this.pageConfig.pageNo,
        pageSize: this.pageConfig.pageSize,
        approvalStatus: 1,
        status:0,
      }).then(res => {
          // console.log(res);
          this.tableData = res.content.list;
          this.pageConfig.total = res.content.count;
          for (const item of this.personList) {
            if(tabId== item.id){
              this.regular.introduce = item.introduce;
              this.regular.photo = item.photo;
              // this.regular.menmberList = item.leaders;
              }
          }
      })
      this.getConsultOrg(tabId)
    },
  },
  mounted() {
    // this.getPersonList()
    this.getOrgList()
    this.findConsultPersonTypeList()
  },
  created() { 
  }
};
</script>

<style lang="less">
.zjimg{
  position: absolute;
  top: 5px;
  right: -80px;
}
.threestyleimg {
  display: flex;
  // align-items: center;
  // justify-content: center;
  flex-wrap: wrap;
  .threestyleimgtu {
    width: 80%;
    height: 70%;
    // background-color: red;
    display: flex;
    // justify-content: center;
    // align-items: center;
  }
  .threestyleimgbtn {
    width: 80%;
    height: 30%;
    margin-top: 20px;

    // background-color: green;
    display: flex;
    // justify-content: center;
    // align-items: center;

    position: relative;
    div {
      width: 170px;
      height: 30%;
      background: #ffffff;
      border: 1px solid #cad4dc;
      text-align: center;
      line-height: 30px;
    }
    input {
      position: absolute;
      width: 172px;
      height: 32px;
      opacity: 0;
      cursor: pointer;
    }
  }
}

a {
  text-decoration: none;
  color: #333333;
}

.newSectionBox {
  min-width: 1366px;
}

.newSectionBox .left_box {
  // background-color: #d0f0fa !important;
  width: 240px !important;
}

.newSectionBox .left_box::-webkit-scrollbar {
  display: none;
}

.newSectionBox .left_box .el-menu .el-submenu .el-menu-item {
  border-top: 1px solid #7cd3ea;
}

.el-menu-item.is-active {
  color: #000000;
}

.item:hover {
  outline: 0;
  background: #fdfeeb;
}

.newSectionBox {
  position: relative;
  display: flex;
  flex-direction: row;
  height: calc(100% - 95px);
  background: #f4f4f4;
}

.newSectionBox .left_box {
  height: calc(100% - 25px) !important;
  min-height: calc(100% - 25px) !important;
}

.newSectionBox .arrowLeft {
  position: absolute;
  top: 50%;
  left: 240px;
  z-index: 2;
  transform: translate(0px, -50%);
  cursor: pointer;
}

.newSectionBox .arrowLeftTwo {
  position: absolute;
  top: 50%;
  left: 0px;
  z-index: 2;
  transform: translate(0px, -50%);
  cursor: pointer;
}

.newSectionBox .leftHeadImg {
  width: 100%;
  cursor: pointer;
}

.newSectionBox .leftListBox {
  background-color: #fff;
}

.newSectionBox > .right_box {
  height: calc(100% - 25px) !important;
  min-height: calc(100% - 25px);
  width: calc(100% - 256px);
  margin-left: 256px !important;
}

.newSectionBox > .right_box_two {
  height: calc(100% - 25px) !important;
  min-height: calc(100% - 25px);
  width: calc(100% - 20px);
  margin-left: 10px !important;
  overflow-y: auto;
}

.newSectionBox .searchBox {
  /* margin-top: 10px; */
  width: 100%;
  /* padding: 10px; */
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  padding-top: 16px;
  padding-bottom: 16px;
}

.newSectionBox .searchBox .el-input {
  position: relative;
  font-size: 14px;
  display: inline-block;
  width: 218px;
}

.left_box .el-input--suffix .el-input__inner {
  padding-right: 30px;
  border: 1px solid #03abee;
  border-radius: 20px;
  /* width: 218px; */
}

.newSectionBox .newSectionBox .el-input__icon {
  height: 100%;
  width: 25px;
  text-align: center;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  // line-height: 40px;
  font-size: 18px;
  color: #03abee;
  font-weight: bold;
}

.newSectionBox .listBox {
  background-color: #fff;
  /*margin-top: 16px;*/
}

.newSectionBox .el-menu-item-group__title {
  padding: 0px 0px 0px 20px;
}

.el-collapse-item {
}

.menuBox {
  box-sizing: border-box;
  padding: 0 0 0 10px;
  font-size: 15px;
  // background: url("@/assets/images/a2.png") no-repeat;
  background-size: 100% 100%;
  color: #ffffff;
}

.menuBox img {
  vertical-align: middle;
  margin-right: 5px;
}

.menuBox span {
  vertical-align: middle;
}

.menuItem { 
  .dian {
    display: inline-block;
    width: 3px;
    height: 3px;
    background-color: #00a1ff;
    vertical-align: middle;
    margin-right: 12px;
  }
}

.menuItem .itemIndex {
  line-height: 40px;
  // background: url("@/assets/images/tiao.png") #d0f0fa no-repeat
  //   bottom;
}

.menuItem .itemList {
  height: 50px;
  line-height: 50px;
}

.menuItem .itemIndex a {
  display: inline-block;
  width: 100%;
}

.menuItem .itemIndex img {
  vertical-align: middle;
  margin-right: 7px;
}

.menuItem .el-submenu__title {
  height: 50px;
  line-height: 50px;
}

.newSectionBox .iteBox .is-active {
  background: #fdfeeb;
}

.newSectionBox .el-menu-item.is-active i {
  color: red;
  font-weight: bold;
}

.newSectionBox .el-submenu [class^="el-icon-"] {
  color: #169cd1;
  font-weight: bold;
}

.newSectionBox .el-input__icon {
  height: 100%;
  width: 25px;
  text-align: center;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  // line-height: 40px;
  font-size: 18px;
  color: #0292cb;
  font-weight: bold;
  margin-right: 10px;
}

.newSectionBox .el-input__inner::placeholder {
  color: #2a2a2a;
}

/* 谷歌 */
.newSectionBox .el-input__inner::-webkit-input-placeholder {
  color: #2a2a2a;
}

/* 火狐 */
.newSectionBox .el-input__inner:-moz-placeholder {
  color: #2a2a2a;
}

/*ie*/
.newSectionBox .el-input__inner:-ms-input-placeholder {
  color: #2a2a2a;
}

.sectionBox > .right_box {
  height: auto;
}

a {
  text-decoration: none;
}

.clear {
  clear: both;
}

.mt-20 {
  margin-top: 20px;
}

.newIndexNew {
  padding: 0px 0px 25px 0px;
  display: flex;
  flex-direction: row;
}

.leftAllBox {
  background-color: #eef1f6;
  padding: 16px;
  box-sizing: border-box;
  width: 100%;
  min-width: 1381px;
}

.box1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.active-notice-right {
  width: calc(100% - 265px);
  flex: 1;
  margin-left: 10px;
}

.active-notice {
  height: 290px;
  background: #fff;
  float: left;
  // height: 364px;
}

.active-notice img {
  width: 100%;
  height: auto;
}

.handle-list {
  box-sizing: border-box;
  padding: 0 20px;
}

.handle {
  flex: 1;
  // width: 625px;
  height: 100%;
  background: #fff;
  overflow: hidden;
}

.box-title {
  display: flex;
  justify-content: space-between;
  line-height: 58px;
  height: 58px;
  box-sizing: border-box;
  padding-left: 22px;
  padding-right: 22px;
}

.active-notice-icon {
  font-weight: bold;
  font-size: 18px;
}

.box-content {
  display: flex;
  padding: 10px;
  box-sizing: border-box;
  position: relative;
  height: 100%;
}

.box-content > .jdjieshao {
  display: inline-block;
  padding: 15px;
  font-size: 18px;
  color: #01aaef;
  line-height: 30px;
  text-indent: 36px;
  font-weight: 600;
  overflow: hidden;
}

.memeber1{
  display: flex;
  justify-content: flex-start;
  padding: 15px;
  text-align: center;
  color: #01aaef;

  img {
    width: 156px;
    height: 156px;
  }

  p {
    margin-top: 10px;
    font-size: 20px;
    font-weight: 600;
  }

  div {
    flex: 1;
    margin: 10px;
  }
} 

/*.active-notice-right{*/
/*    padding-bottom: 20px;*/
/*}*/
.active-notice-right .box-content {
  height: 280px;
  min-width: 100%;
  overflow-x: auto;
}

.yzListUl {
  position: relative;
}

.yzListDivLeft {
  width: 206px;
  height: 130px;
  display: flex;
  flex-direction: row;
  align-items: center;
  /*padding-left: 50px;*/
  padding-left: 25px;
  margin-bottom: 6px;
  border-radius: 6px;
  cursor: pointer;
}

.yzListDivLeft img {
  width: 41px;
  margin-right: 25px;
}

.yzListDivLeftBlue {
  background: #bcdef8;
}

.yzListDivLeftBlue div p {
  font-size: 21px;
  color: #0b54c1;
  font-weight: bold;
}

.yzListDivLeftBlue div span {
  font-size: 13px;
  color: #0b54c1;
  font-weight: bold;
  letter-spacing: -0.5px;
}

.yzListDivLeftViolet {
  background: #e3daeb;
}

.yzListDivLeftViolet div p {
  font-size: 21px;
  color: #90489f;
  font-weight: bold;
}

.yzListDivLeftViolet div span {
  font-size: 13px;
  color: #90489f;
  font-weight: bold;
  letter-spacing: -0.5px;
}

.yzListDivLeftBrown {
  background: #f6e7d4;
}

.yzListDivLeftBrown div p {
  font-size: 18px;
  color: #be732d;
  font-weight: bold;
}

.yzListDivLeftBrown div span {
  font-size: 13px;
  color: #be732d;
  font-weight: bold;
  letter-spacing: -0.5px;
}

.conBox {
  width: 48%;
  height: 303px;
  float: left;
}

.leftContent {
  border: 1px solid #f2f0f1;
  background-color: #faf9fa;
}

.conBox ul {
  width: 100%;
  height: 100%;
  padding-left: 10px;
  padding-top: 20px;
}

.sjList {
  width: 100%;
  /*float: left;*/
  font-size: 14px;
  font-weight: 400;
  color: rgba(94, 93, 95, 1);
  line-height: 30px;
  padding-left: 25px;
  box-sizing: border-box;
  // background: url("../../../../assets/images/listStyle.png") no-repeat -2px
  // center;
  background-size: auto 100%;
}

.sjList span {
  color: #e80000;
  font-size: 16px;
}

.box2 {
  box-sizing: border-box;
  padding: 10px 0;
}

.newIndexNew .box2 {
  width: auto;
}

.box2Content {
  background-color: #fff;
  width: 100%;
  height: 100%;
}

.workBox {
  max-height: 345px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.work1 {
  width: 25%;
  border: 1px solid #f2f0f1;
  background-color: #faf9fa;
  padding: 20px;
  float: left;
  margin-right: 10px;
}

.work1Title {
  font-size: 18px;
  margin-top: 20px;
  margin-bottom: 30px;
  font-weight: bold;
}

.work1Content li {
  line-height: 40px;
  font-size: 14px;
}

.text-center {
  text-align: center;
}

.workBoxRight {
  width: calc(50% - 40px);
  border: 1px solid #f2f0f1;
  background-color: #faf9fa;
  padding: 20px;
  float: left;
  margin-right: 10px;
}

.myTopImg {
  vertical-align: middle;
  margin-right: 10px;
}

.workRightContent {
  width: 50%;
  padding-left: 40px;
  float: left;
  box-sizing: border-box;
}

.workBoxRight .workRightContent {
  padding-left: 0px;
}

.workRightTitle {
  display: inline-block;
  border: 1px solid #f2f0f1;
  padding: 5px 20px;
  border-radius: 10px;
}

.workRightList li {
  line-height: 30px;
}

.workRightList {
  margin-top: 20px;
}

.workRightList li img {
  width: 20px;
  vertical-align: middle;
}

.zan {
  display: inline-block;
  width: 20px;
}

.workRightList .topNum {
  display: inline-block;
  width: 20px;
  height: 20px;
  color: #ffffff;
  background: #e90001;
  text-align: center;
  line-height: 20px;
  border-radius: 50%;
  margin-left: 20px;
  margin-right: 10px;
}

.workRightList .topName {
  /*font-size: 14px;*/
}

.rightAllBox {
  /*position: absolute;*/
  /*right: 0;*/
  /*top: 0;*/
  width: 266px;
}

.rightAllTitleBox {
  width: calc(100% - 30px);
  // background: url("@/assets/images/y1.png") no-repeat;
  background-size: 100% 100%;
  padding: 15px;
}

.rightAllTitleBox img {
  vertical-align: middle;
  margin-right: 5px;
}

.rightAllTitle {
  font-size: 18px;
  /*font-weight: bold;*/
}

.wgState {
  font-size: 16px;
  color: #ffffff;
  margin-top: 5px;
  text-align: left;
  font-weight: 700;
  padding-left: 40px;
}

.wgState span {
  color: #d40000;
}

.wgzl {
  background-color: #fff;
  margin-top: 10px;
  padding: 15px;
}

.wgzlTitle {
  font-size: 14px;
  font-weight: bold;
}

.wgzlTitle span {
  float: right;
  font-size: 12px;
  color: #de0606;
  cursor: pointer;
}

.wgzlContent {
  margin-top: 10px;
  /*height: 200px;*/
  overflow-y: scroll;
}

.wgzlText {
  color: #585858;
  font-size: 14px;
  line-height: 30px;
  border-bottom: 1px solid #f4f4f4;
  margin-top: 10px;
}

/*.wgzlText img {*/
/*    margin-right: 5px;*/
/*    vertical-align: middle;*/
/*}*/
.leftImg {
  float: left;
}

.rightTextBox {
  float: left;
  padding-left: 10px;
}

.rightTextBox p {
  height: 20px;
  line-height: 20px;
}

.rightTextBoxP {
  margin-bottom: 10px;
}

.rightBox {
  float: right;
}

.stateText {
  color: #fd1f1f;
  font-weight: normal;
  font-size: 16px;
}

.userText {
  color: #ffffff;
  font-weight: bold;
  padding-left: 15px;
}

.moreRight {
  float: right;
  color: #de0606;
  cursor: pointer;
}

.menuList ul {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.menuList ul li {
  color: #000;
  margin-left: 14px;
  cursor: pointer;
}

.menuList ul li.cur {
  color: #00aaee;
  margin-left: 14px;
  cursor: pointer;
  border-bottom: 2px solid #00aaee;
  padding-bottom: 4px;
}

.mapList {
  position: absolute;
  top: 20px;
  left: 40px;
  z-index: 999;
}

.mapList ul {
  display: flex;
  flex-direction: row;
  align-items: center;
  background: #073b57;
  width: 195px;
  height: 48px;
  border: 2px solid #125c70;
  border-radius: 6px;
}

.mapList ul li {
  color: #ace1fa;
  display: flex;
  flex-direction: column;
  font-size: 12px;
  width: 65px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 100%;
}

.mapList ul li:first-child {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

.mapList ul li:last-child {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.mapList ul li:hover {
  background: #06396b;
}

.mapList ul li img {
  width: 16px;
  height: 16px;
  margin-bottom: 6px;
}

// @media screen and (max-width: 1919px) {
//   .box1 {
//     display: flex;
//     flex-direction: row;
//     height: auto;
//     margin-bottom: 0px;
//     justify-content: space-between;
//     padding-left: 0px;
//     padding-right: 10px;
//   }

//   .yzListDivLeft {
//     width: 138px;
//     padding-left: 10px;
//     height: 80px;
//     /*height:106px;*/
//   }

//   .active-notice-right {
//     height: 330px;
//     padding-right: 0px;
//     padding-bottom: 0px;
//   }

//   .yzListDivLeft img {
//     width: 28px;
//     margin-right: 10px;
//   }

//   .active-notice {
//     // width: calc(100% - 20px);
//     margin-bottom: 10px;
//     height: 262px;
//     padding-top: 10px;
//   }

//   .yzListDivLeftBlue div p {
//     font-size: 14px;
//     color: #0b54c1;
//     font-weight: bold;
//   }

//   .yzListDivLeftViolet div p {
//     font-size: 14px;
//     color: #90489f;
//     font-weight: bold;
//   }

//   .yzListDivLeftBrown div p {
//     font-size: 14px;
//     color: #be732d;
//     font-weight: bold;
//   }

//   .yzListDivLeftViolet div span,
//   .yzListDivLeftBlue div span,
//   .yzListDivLeftBrown div span {
//     font-size: 12px;
//     letter-spacing: -1.5px;
//   }

//   .box-content {
//     padding: 0px 10px;
//     height: auto;
//   }

//   .box2 {
//     padding: 0px 10px 0px 0px;
//   }

//   .active-notice-right .box-content {
//     height: 252px;
//     /*height:330px*/
//   }
// }

.echarts {
  background-color: #fcfafb;

  .paiming {
    font-size: 16px;
    height: 52px;
    line-height: 52px;
    padding-left: 28px;
  }

  .tabbar {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-size: 15px;
    height: 36px;
    border: 1px solid #c7c7c7;
    margin-left: 6%;
    margin-right: 6%;
    align-items: center;
    border-radius: 6px;
  }
}

.search {
  position: absolute;
  z-index: 999999;
  display: flex;
  cursor: default;
  justify-content: space-around;
  top: 20px;
  left: 0;
  right: 0;
  margin: auto;
  font-size: 12px;

  div {
    &:hover > ul {
      height: 90px;
    }
  }

  p {
    border: 1px solid #fff;
    border-radius: 4px;
    line-height: 30px;
    width: 120px;
    text-align: center;
    color: #fff;
  }

  ul {
    transition: 0.5s;
    height: 0;
    overflow: hidden;

    li {
      text-align: center;
      line-height: 30px;
      color: #fff;
      background-color: rgba(255, 255, 255, 0.3);

      &:hover {
        background-color: rgba(255, 255, 255, 0.5);
      }
    }
  }
}

.yearDay {
  position: absolute;
  z-index: 99;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  font-size: 14px;
}

/*我的工作*/
.workBoxContent {
  width: calc(20% - 10px);
  max-width: 354px;
  min-height: 300px;
  max-height: 345px;
  border: 1px solid rgba(242, 240, 241, 1);
  position: relative;
}

.tabbar p {
  width: calc(50% - 0.5px);
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  cursor: pointer;
}

.tabbar div {
  width: 1px;
  height: 100%;
  background: #c7c7c7;
}

.tabbar .cur {
  background: #f5f5f5;
  color: #e90000;
}

.tabCon {
  margin-left: 6%;
  margin-right: 6%;
  padding-top: 16px;
}

.tabCon ul li {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 16px;
  position: relative;
  padding-left: 70px;
}

.tabCon ul li img {
  position: absolute;
  left: 0px;
}

.tabCon ul li div {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #e90000;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  color: #ffffff;
  position: absolute;
  left: 35px;
}

.workBoxContentHead {
  font-size: 16px;
  height: 52px;
  line-height: 52px;
  padding-left: 28px;
  background: #fcfafb;
  display: flex;
}

.yearDay span {
  margin-right: 20px;
  cursor: pointer;
}

/*事件受理样式 start*/
// .el-button + .el-button {
//   margin-left: 0px;
//   border-radius: 0px;
// }

// .el-button {
//   border-radius: 0px;
//   background: #ffffff;
//   color: #909399;
//   border-color: #e4e7ed;
//   border-left: none;
//   padding: 10px;
// }

.curButton {
  background: #787676;
  color: #fff;
}

/*事件受理样式 end*/

/*弹框样式 start*/
/deep/ .el-dialog__wrapper {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 530px;
}

@media screen and (max-width: 1919px) {
  /deep/ .el-dialog__wrapper {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding-top: 350px;
  }
}

/deep/ .el-dialog {
  margin: 0 auto !important;
  margin-top: 0px !important;
  width: 62% !important;
  max-width: 620px;
  height: 290px !important;
  overflow: hidden;
}


.backDiv {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
}

/*弹框样式 end*/

/*详细信息样式 start*/
.operationPosition {
  display: flex;
  flex-direction: row;
  position: absolute;
  right: 30px;
  top: 16px;
}

.zhipaiDiv {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 20px;
  flex: 1;
  width: 100%;
  left: 0px;
}

.zhipai {
  width: 67px;
  height: 31px;
  background: #00aaee;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  color: #ffffff;
  border: none;
  margin-right: 10px;
}

.fanhui {
  width: 67px;
  height: 31px;
  background: #a3a8aa;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px !important;
  color: #ffffff;
  border: none;
}

/deep/ .el-card__body {
  padding: 16px 12px 0px 12px;
  width: 100%;
  display: flex;
  flex-direction: row;
}

/deep/ .el-tabs__content {
  font-size: 14px;
}

/deep/ .el-row {
  margin-bottom: 10px;
}

.detailContent {
  height: 280px;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: row;
}

.detailContentRight {
  display: flex;
  position: relative;
  width: calc(100% - 330px);
  flex-direction: row;
}

.detailContetnRightDiv {
  display: inline-block;
  width: 250px;
  height: calc(100% - 28px);
  margin-right: 15px;
  margin-top: 14px;
  margin-bottom: 14px;
  overflow: hidden;
}

.detailImg {
  width: 100%;
  /*margin-top: 60px;*/
}

/*详细信息样式 end */

/*modal 样式 start*/
/deep/ .el-dialog__body {
  padding: 0px 26px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
  overflow-y: auto;
  height: calc(100% - 42px);
  overflow-x: hidden;
}

/deep/ .el-dialog__body img {
  width: 100%;
  margin-top: 16px;
}

.dialogDiv {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 8px;
  height: 42px;
}

.dialogDiv .el-input--suffix .el-input__inner {
  border: 1px solid #dcdfe6 !important;
  border-radius: 4px !important;
  margin-right: 10px;
}

.dialogDiv .el-select {
  margin-right: 10px;
}

.dialogSpan {
  min-width: 62px;
}

.ml16 {
  margin-left: 16px;
}

/deep/ .el-dialog__body .el-textarea {
  margin-left: 16px;
}

.tijiao {
  margin: 20px auto;
}

/*modal 样式 end */
.newIndexNew /deep/ .el-dialog__headerbtn:focus .el-dialog__close,
.newIndexNew /deep/ .el-dialog__headerbtn:hover .el-dialog__close {
  color: #fff;
}

.newIndexNew /deep/ .cell.el-tooltip {
  cursor: pointer;
}

.Action_buttons {
  margin-bottom: 15px;
}

.newIndexNew /deep/ .el-pagination {
  margin-top: 15px;
}

/deep/ .el-dialog__body .el-input__prefix {
  left: -8px;
  top: -8px;
}

.yzsblContent {
  position: relative;
  padding: 15px 0px;
}

.yzsbl {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.yzsbl h5 {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
}

.dialogDivYzs {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 14px;
  margin-bottom: 10px;
}

.dialogDivYzs img {
  margin-left: 40px;
}

.yzsblContent .operation {
  position: absolute;
  right: 15px;
  top: 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.timeLine {
  width: 390px;
  margin-top: 50px;
  margin-bottom: 60px;
}

.timeLine /deep/ .el-timeline {
  display: flex;
  flex-direction: revert;
  align-items: center;
  margin-left: 30px;
  
}

.timeLine /deep/ .el-timeline-item {
  width: 180px;
  height: 22px;
  padding-bottom: 0px;
}

.timeLine /deep/ .el-timeline-item__tail {
  position: absolute;
  left: 4px;
  height: 2px;
  width: 114px;
  background: #e4e7ed;
  top: 4px;
}

.timeLine /deep/ .el-timeline-item__wrapper {
  position: relative;
  padding-left: 0px;
  top: auto;
  bottom: -20px;
  left: -22px;
}

.timeLine /deep/ .el-timeline-item__content {
  width: 112px;
}

.ml30 {
  margin-left: 30px;
}

.banzheng /deep/ .el-carousel__item {
  display: flex;
  justify-content: center;
  align-items: center;
}

.telephone {
  width: 26px;
  height: 26px;
  border-radius: 50%;
}
// 面包屑导航box
.mianbao {
  box-sizing: border-box;
  margin: -16px -16px 0;
  background-color: #fff;
  height: 47px;
  display: flex;
  align-items: center;
  padding-left: 16px;
  margin-bottom: 16px;
}

.left-title {
  height: 40px;
  line-height: 40px;
  font-size: 26px;
  text-align: center;
  background-color: rgb(25, 202, 233);
}

.itemIndex {
  .el-menu {
    background-color: #d0f0fa !important;
  }
}

.left-top-btn {
  display: flex;
  justify-content: space-around;
  margin: 10px 0 10px 0;
  padding-left: 10px;
  font-size: 15px;
  position: relative;

  img {
    &:hover {
      cursor: pointer;
    }
  }
}
.threestyleimgbtn {
    width: 80%;
    height: 30%;
    // background-color: green;
    display: flex;
    // justify-content: center;
    // align-items: center;

    position: relative;
    div {
      width: 170px;
      height: 30%;
      background: #ffffff;
      border: 1px solid #cad4dc;
      text-align: center;
      line-height: 30px;
    }
    input {
      position: absolute;
      width: 172px;
      height: 32px;
      opacity: 0;
      cursor: pointer;
    }
  }
.submenuText {
  .aside-list {
    padding: 0 0 0 15px !important;
    font-size: 15px;

    &:hover {
      background-color: rgba(76, 201, 240, 1);
      -webkit-box-shadow: 10px 10px 99px 6px rgba(76, 201, 240, 1);
      -moz-box-shadow: 10px 10px 99px 6px rgba(76, 201, 240, 1);
      box-shadow: 10px 10px 99px 6px rgba(76, 201, 240, 1);
      transform: scale(1.1);
    }
  }
}

.ziliaoguidang {
  //display: flex;
  //flex-direction: row;
  height: 200px;

  &:first-child {
    margin-top: 5px;
    margin-bottom: 5px;
  }

  .btn-column {
    box-sizing: border-box;
    display: inline-block;
    width: 60px;
    background-color: #f4b084;
    line-height: 30px;
    padding: 15px;
    font-size: 16px;
    height: 200px;
    text-align: center;
    border: 1px solid black;
    cursor: pointer;
    border-top-left-radius: 24px 5px;
    border-top-right-radius: 24px 5px;
    border-bottom-left-radius: 24px 5px;
    border-bottom-right-radius: 24px 5px;

    &:hover {
      background-color: rgba(76, 201, 240, 1);
      -webkit-box-shadow: 10px 10px 99px 6px rgba(76, 201, 240, 1);
      -moz-box-shadow: 10px 10px 99px 6px rgba(76, 201, 240, 1);
      box-shadow: 10px 10px 99px 6px rgba(76, 201, 240, 1);
      transform: scale(1.1);
    }

    &:last-child {
      border-right: none;
    }
  }
}

.menuItem .el-submenu__title {
  padding: 0 !important;
}

.communityVoluntaryService {
  padding: 0;
}
.winput{
  width: 60%;
}
.el-form-item{
  margin-top: 15px;
}
</style>
